export default __webpack_public_path__ + "static/media/favourite_active_black.f84f1ec7.svg";